import { IProduct } from '@inter-ikea-kompis/types/lib';
import { TotalPriceCalculator } from '@inter-ikea-kompis/utilities/lib';
import { product2ShoppingProduct } from 'redux-store/products/products.utils';
import { IAppSettings } from 'redux-store/settings/settings.store';

export const getTotalAmountForProducts = (products: IProduct[], settings: IAppSettings): number => {
  const totalPricesDualCurrency = TotalPriceCalculator.calculateMultiple(
    products.map(product2ShoppingProduct),
    settings.localisation.dateFormat
  );

  return totalPricesDualCurrency[0].inclTax;
};
